import React from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Button,
  Box,
  Typography,
  useTheme,
  Container,
  Grid,
  useMediaQuery,
  FormControl,
  FormHelperText,
  TextField,
  Divider,
  FormControlLabel,
  Radio,
  RadioGroup,
  MenuItem,
  Select,
  InputLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { Doughnut } from "react-chartjs-2";

export default function InterestCalculationPage() {
  const theme = useTheme();
  return (
    <Box
      style={{
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <InterestCalculation />
      <Divider
        variant="middle"
        style={{
          backgroundColor: theme.palette.secondary.light,
          height: "2px",
          width: "80%",
          margin: "30px 0px",
        }}
      />
      <CreditTable />
    </Box>
  );
}

function InterestCalculation() {
  const theme = useTheme();
  const isPhone = useMediaQuery("(max-width:446px)");
  const isPad = useMediaQuery("(max-width:700px)");
  const isTable = useMediaQuery("(max-width:1120px)");
  const useStyles = makeStyles((theme) => ({
    input: {
      width: isPhone ? "220px" : "auto",
    },
    inputpi: {
      width: isPhone ? "220px" : "120px",
    },
    radio: {
      "& .MuiRadio-colorSecondary.Mui-checked": {
        color: theme.palette.primary.main,
      },
    },
  }));
  const classes = useStyles();

  const { handleSubmit, control } = useForm({
    defaultValues: {
      creditItem: "",
      creditMethod: "",
      totalPrice: "",
      downPayment: "",
      downPaymentPercentage: "",
      creditDeadline: "",
      creditGracePeriod: "",
      interestMethod: "",
      interestYear: "",
      interestYearPercentage: "",
    },
  });

  const year = [
    "1年",
    "2年",
    "3年",
    "4年",
    "5年",
    "6年",
    "7年",
    "8年",
    "9年",
    "10年",
    "11年",
    "12年",
    "13年",
    "14年",
    "15年",
    "16年",
    "17年",
    "18年",
    "19年",
    "20年",
    "21年",
    "22年",
    "23年",
    "24年",
    "25年",
    "26年",
    "27年",
    "28年",
    "29年",
    "30年",
  ];

  //ANCHOR 圖表設定
  const data = {
    datasets: [
      {
        data: [90, 10],
        backgroundColor: ["#E1B663", "#103775"],
      },
    ],
  };

  const options = {
    responsive: false,
    cutout: isPhone ? 80 : 115,
  };

  //輸出表單資料
  function _submit(data) {
    console.log(data);
    const userInput = {
      ...data,
    };
  }

  const [interestYear, setInterestYear] = React.useState("");
  const [method, setMethod] = React.useState("");
  const [deadline, setDeadline] = React.useState("");
  const [gracePeriod, setGracePeriod] = React.useState("");
  const [interest, setInterest] = React.useState("");

  return (
    <Container maxWidth="lg">
      <Box>
        <Grid container justifyContent="center">
          <Grid container item xs={12} sm={10} md={isTable ? 7 : 5}>
            {/* ANCHOR 利息試算表單 */}
            <Grid item xs={12} style={{ marginTop: "50px" }}>
              <InputLabel>貸款類型</InputLabel>
              <Controller
                rules={{ required: "請選擇貸款類型" }}
                control={control}
                name="creditItem"
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <FormControl error={error}>
                    <RadioGroup
                      row
                      value={value}
                      onChange={onChange}
                      className={classes.radio}
                    >
                      <FormControlLabel
                        value="一般貸款"
                        control={<Radio />}
                        label="一般貸款"
                      />
                      <FormControlLabel
                        value="青安貸款"
                        control={<Radio />}
                        label="青安貸款"
                      />
                      <FormControlLabel
                        value="組合貸款"
                        control={<Radio />}
                        label="組合貸款"
                      />
                    </RadioGroup>
                    <FormHelperText style={{ left: 15, bottom: "-40%" }}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: "30px" }}>
              <InputLabel style={{ marginBottom: "5px" }}>貸款方式</InputLabel>
              <Controller
                control={control}
                name="creditMethod"
                rules={{
                  required: "請選擇貸款方式",
                }}
                render={({
                  field: { onChange, ...otherField },
                  fieldState: { error },
                }) => (
                  <FormControl size="small" variant="outlined" error={error}>
                    <Select
                      {...otherField}
                      value={method}
                      displayEmpty
                      style={{ width: isPhone ? "220px" : "auto" }}
                      onChange={(event) => {
                        setMethod(event.target.value);
                        onChange(event);
                      }}
                      renderValue={
                        method === ""
                          ? () => (
                              <span style={{ color: "#9E9E9E" }}>
                                請選擇貸款方式
                              </span>
                            )
                          : undefined
                      }
                    >
                      <MenuItem value="本息平均攤還">本息平均攤還</MenuItem>
                      <MenuItem value="本金平均攤還">本金平均攤還</MenuItem>
                      <MenuItem value="到期還本">到期還本</MenuItem>
                    </Select>
                    <FormHelperText style={{ bottom: "-50%" }}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid item xs={12} style={{ marginTop: "30px" }}>
              <InputLabel style={{ marginBottom: "5px" }}>房屋總價</InputLabel>
              <Controller
                name="totalPrice"
                control={control}
                rules={{
                  required: "請輸入房屋總價",
                }}
                render={({ field, fieldState: { error } }) => (
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      placeholder="請輸入房屋總價"
                      {...field}
                      className={classes.input}
                      error={error}
                      helperText={error && error.message}
                    />
                    <Typography
                      style={{ fontSize: "1.25rem", marginLeft: "10px" }}
                    >
                      萬元
                    </Typography>
                  </Grid>
                )}
              />
            </Grid>
            <Grid container item xs={12} style={{ marginTop: "30px" }}>
              <Grid item>
                <InputLabel style={{ marginBottom: "5px" }}>首付</InputLabel>
                <Controller
                  name="downPayment"
                  control={control}
                  rules={{
                    required: "請輸入首付價格",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <Grid style={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        placeholder="請輸入首付價格"
                        {...field}
                        className={classes.input}
                        error={error}
                        helperText={error && error.message}
                      />
                      <Typography
                        style={{ fontSize: "1.25rem", margin: "0px 10px" }}
                      >
                        萬元
                      </Typography>
                    </Grid>
                  )}
                />
              </Grid>
              <Grid item>
                <Controller
                  name="downPaymentPercentage"
                  control={control}
                  rules={{
                    required: "請輸入百分比",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <Grid
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "21px",
                      }}
                    >
                      <TextField
                        {...field}
                        error={error}
                        className={classes.inputpi}
                        helperText={error && error.message}
                      />
                      <Typography
                        style={{ fontSize: "1.25rem", margin: "0px 10px" }}
                      >
                        %
                      </Typography>
                    </Grid>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container item xs={12} style={{ marginTop: "30px" }}>
              <Grid item style={{ marginRight: "15px" }}>
                <InputLabel style={{ marginBottom: "5px" }}>
                  貸款期限
                </InputLabel>
                <Controller
                  control={control}
                  name="creditDeadline"
                  rules={{
                    required: "請選擇貸款期限",
                  }}
                  render={({
                    field: { onChange, ...otherField },
                    fieldState: { error },
                  }) => (
                    <FormControl size="small" variant="outlined" error={error}>
                      <Select
                        {...otherField}
                        value={deadline}
                        displayEmpty
                        style={{ width: isPhone ? "220px" : "auto" }}
                        onChange={(event) => {
                          setDeadline(event.target.value);
                          onChange(event);
                        }}
                        renderValue={
                          deadline === ""
                            ? () => (
                                <span style={{ color: "#9E9E9E" }}>
                                  請選擇貸款期限
                                </span>
                              )
                            : undefined
                        }
                      >
                        {year.map((item, index) => {
                          return <MenuItem value={index}>{item}</MenuItem>;
                        })}
                      </Select>
                      <FormHelperText style={{ bottom: "-50%" }}>
                        {error && error.message}
                      </FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item style={{ marginTop: isPhone ? "30px" : "0px" }}>
                <InputLabel style={{ marginBottom: "5px" }}>寬限期</InputLabel>
                <Controller
                  control={control}
                  name="creditGracePeriod"
                  rules={{
                    required: "請選擇貸款寬限期",
                  }}
                  render={({
                    field: { onChange, ...otherField },
                    fieldState: { error },
                  }) => (
                    <FormControl size="small" variant="outlined" error={error}>
                      <Select
                        {...otherField}
                        value={gracePeriod}
                        style={{ width: isPhone ? "220px" : "auto" }}
                        displayEmpty
                        onChange={(event) => {
                          setGracePeriod(event.target.value);
                          onChange(event);
                        }}
                        renderValue={
                          gracePeriod === ""
                            ? () => (
                                <span style={{ color: "#9E9E9E" }}>
                                  請選擇貸款寬限期
                                </span>
                              )
                            : undefined
                        }
                      >
                        {year.map((item, index) => {
                          return <MenuItem value={index}>{item}</MenuItem>;
                        })}
                      </Select>
                      <FormHelperText style={{ bottom: "-50%" }}>
                        {error && error.message}
                      </FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: "30px" }}>
              <InputLabel style={{ marginBottom: "5px" }}>利率方式</InputLabel>
              <Controller
                control={control}
                name="interestMethod"
                rules={{
                  required: "請選擇利率方式",
                }}
                render={({
                  field: { onChange, ...otherField },
                  fieldState: { error },
                }) => (
                  <FormControl size="small" variant="outlined" error={error}>
                    <Select
                      {...otherField}
                      value={interest}
                      displayEmpty
                      style={{ width: isPhone ? "220px" : "auto" }}
                      onChange={(event) => {
                        setInterest(event.target.value);
                        onChange(event);
                      }}
                      renderValue={
                        interest === ""
                          ? () => (
                              <span style={{ color: "#9E9E9E" }}>
                                請選擇利率方式
                              </span>
                            )
                          : undefined
                      }
                    >
                      <MenuItem value="固定利率">固定利率</MenuItem>
                      <MenuItem value="機動利率">機動利率</MenuItem>
                    </Select>
                    <FormHelperText style={{ bottom: "-50%" }}>
                      {error && error.message}
                    </FormHelperText>
                  </FormControl>
                )}
              />
            </Grid>
            <Grid container item xs={12} style={{ marginTop: "30px" }}>
              <Grid item style={{ marginRight: "15px" }}>
                <InputLabel style={{ marginBottom: "5px" }}>年利率</InputLabel>
                <Controller
                  control={control}
                  name="interestYear"
                  rules={{
                    required: "請選擇年利率",
                  }}
                  render={({
                    field: { onChange, ...otherField },
                    fieldState: { error },
                  }) => (
                    <FormControl size="small" variant="outlined" error={error}>
                      <Select
                        {...otherField}
                        value={interestYear}
                        displayEmpty
                        style={{ width: isPhone ? "220px" : "auto" }}
                        onChange={(event) => {
                          setInterestYear(event.target.value);
                          onChange(event);
                        }}
                        renderValue={
                          interestYear === ""
                            ? () => (
                                <span style={{ color: "#9E9E9E" }}>
                                  請選擇年利率
                                </span>
                              )
                            : undefined
                        }
                      >
                        {year.map((item, index) => {
                          return <MenuItem value={index}>{item}</MenuItem>;
                        })}
                      </Select>
                      <FormHelperText style={{ bottom: "-50%" }}>
                        {error && error.message}
                      </FormHelperText>
                    </FormControl>
                  )}
                />
              </Grid>
              <Grid item>
                <Controller
                  name="interestYearPercentage"
                  control={control}
                  rules={{
                    required: "請輸入百分比",
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <Grid
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginTop: "21px",
                      }}
                    >
                      <TextField
                        {...field}
                        error={error}
                        className={classes.inputpi}
                        helperText={error && error.message}
                      />
                      <Typography
                        style={{ fontSize: "1.25rem", margin: "0px 10px" }}
                      >
                        %
                      </Typography>
                    </Grid>
                  )}
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                variant="contained"
                onClick={handleSubmit(_submit)}
                style={{
                  color: "#fff",
                  backgroundColor: theme.palette.secondary.light,
                  borderRadius: "40px",
                  height: "50px",
                  width: "220px",
                  margin: "30px 0px",
                }}
              >
                開始計算
              </Button>
            </Grid>
          </Grid>
          {/* ANCHOR 圖表 */}
          <Grid
            item
            xs={isTable ? 12 : 7}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <Grid style={{ marginTop: "50px" }}>
              <Typography
                variant="h4"
                color="primary"
                style={{ fontWeight: 700 }}
              >
                房貸利息試算
              </Typography>
            </Grid>
            <Grid container>
              <Grid item xs={isPad ? 12 : 6} style={{ position: "relative" }}>
                <Grid
                  style={{
                    position: "absolute",
                    top: "40%",
                    left: "50%",
                    width: "250px",
                    transform: "translate(-50%,-50%)",
                    textAlign: "center",
                  }}
                >
                  <Typography variant={isPhone ? "subtitle1" : "h6"}>
                    本息平均攤還
                  </Typography>
                  <Typography
                    variant={isPhone ? "h6" : "h5"}
                    style={{ fontWeight: 700 }}
                  >
                    000,000元/月
                  </Typography>
                </Grid>
                {/* ANCHOR 圖表1組件位置 */}
                <Doughnut
                  data={data}
                  options={options}
                  height={isPhone ? 320 : 300}
                  width={isPhone ? 320 : 300}
                  style={{ margin: "50px auto" }}
                />
                <Grid
                  style={{
                    marginLeft: isPhone ? "30%" : "115px",
                  }}
                >
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <Box
                      style={{
                        width: "14px",
                        height: "14px",
                        backgroundColor: theme.palette.secondary.light,
                        borderRadius: "7px",
                      }}
                    />
                    <Typography
                      variant="subtitle1"
                      style={{ marginLeft: "5px" }}
                    >
                      本金（000萬）
                    </Typography>
                  </Grid>
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <Box
                      style={{
                        width: "14px",
                        height: "14px",
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: "7px",
                      }}
                    />
                    <Typography
                      variant="subtitle1"
                      style={{ marginLeft: "5px" }}
                    >
                      利息（000萬）
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography
                      variant="subtitle1"
                      style={{ marginLeft: "19px" }}
                    >
                      本息合計（000萬）
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={isPad ? 12 : 6} style={{ position: "relative" }}>
                <Grid
                  style={{
                    position: "absolute",
                    top: "40%",
                    left: "50%",
                    width: "250px",
                    transform: "translate(-50%,-50%)",
                    textAlign: "center",
                  }}
                >
                  <Typography variant={isPhone ? "subtitle1" : "h6"}>
                    本息平均攤還
                  </Typography>
                  <Typography
                    variant={isPhone ? "h6" : "h5"}
                    style={{ fontWeight: 700 }}
                  >
                    000,000元/月
                  </Typography>
                  <Typography variant={isPhone ? "subtitle1" : "h6"}>
                    每月遞減
                  </Typography>
                </Grid>
                {/* ANCHOR 圖表2組件位置 */}
                <Doughnut
                  data={data}
                  options={options}
                  height={isPhone ? 320 : 300}
                  width={isPhone ? 320 : 300}
                  style={{ margin: "50px auto" }}
                />
                <Grid
                  style={{
                    marginLeft: isPhone ? "30%" : "115px",
                  }}
                >
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <Box
                      style={{
                        width: "14px",
                        height: "14px",
                        backgroundColor: theme.palette.secondary.light,
                        borderRadius: "7px",
                      }}
                    />
                    <Typography
                      variant="subtitle1"
                      style={{ marginLeft: "5px" }}
                    >
                      本金（000萬）
                    </Typography>
                  </Grid>
                  <Grid style={{ display: "flex", alignItems: "center" }}>
                    <Box
                      style={{
                        width: "14px",
                        height: "14px",
                        backgroundColor: theme.palette.primary.main,
                        borderRadius: "7px",
                      }}
                    />
                    <Typography
                      variant="subtitle1"
                      style={{ marginLeft: "5px" }}
                    >
                      利息（000萬）
                    </Typography>
                  </Grid>
                  <Grid>
                    <Typography
                      variant="subtitle1"
                      style={{ marginLeft: "19px" }}
                    >
                      {" "}
                      本息合計（000萬）
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}

//ANCHOR 哪個貸款方式適合我
function CreditTable() {
  const StyledTableCell = withStyles((theme) => ({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: "white",
    },
    root: {
      borderBottom: "0px",
    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: "white",
      },
    },
  }))(TableRow);

  function createData(deadline, interestRate, APR, payment) {
    return { deadline, interestRate, APR, payment };
  }

  const rows = [
    createData(
      "/assets/images/Home/choiceProperty.png",
      "0.00",
      "0.00",
      "1234567"
    ),
    createData(
      "/assets/images/Home/choiceProperty.png",
      "0.00",
      "0.00",
      "1234567"
    ),
    createData(
      "/assets/images/Home/choiceProperty.png",
      "0.00",
      "0.00",
      "1234567"
    ),
    createData(
      "/assets/images/Home/choiceProperty.png",
      "0.00",
      "0.00",
      "1234567"
    ),
  ];
  const theme = useTheme();
  const useStyles = makeStyles({
    table: {
      minWidth: 900,
      "& .MuiTypography-h4": {
        fontWeight: 700,
      },
      "& .MuiTypography-h5": {
        fontWeight: 700,
      },
      "& .MuiTypography-h6": {
        fontWeight: 700,
      },
    },
  });
  const classes = useStyles();

  //千位數方法
  const internationalNumberFormat = new Intl.NumberFormat("en-US");

  return (
    <Container maxWidth={"lg"}>
      <Box my={3}>
        <Grid container justifyContent="center">
          <Grid style={{ marginBottom: "30px" }} item xs={12}>
            <Typography
              variant="h4"
              style={{ fontWeight: 700 }}
              color="primary"
              align="center"
            >
              哪個貸款方式適合我
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <TableContainer>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="center">
                      <Typography variant="h6">40年貸款期限</Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="h6">首期利率</Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="h6">APR</Typography>
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Typography variant="h6">每月付款</Typography>
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((row, index) => (
                    <StyledTableRow key={index}>
                      <StyledTableCell style={{ width: "300px" }}>
                        <img
                          src={row.deadline}
                          alt=""
                          width="256px"
                          height="100px"
                        />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Typography variant="h5">
                          {row.interestRate}%
                        </Typography>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Typography variant="h5">{row.APR}%</Typography>
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        <Typography variant="h5">
                          {internationalNumberFormat.format(row.payment)}/月
                        </Typography>
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              style={{
                color: "#fff",
                backgroundColor: theme.palette.secondary.light,
                borderRadius: "40px",
                height: "50px",
                width: "220px",
                margin: "30px 0px",
              }}
            >
              進一步諮詢
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
}
